import { useState } from "react";
import type { FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await (register as any)(name, email, password);
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Registration failed");
    } finally { setLoading(false); }
  }

  return (
    <div className="ns-login-bg">
      <div className="ns-login-card">
        <div className="ns-login-logo">💎</div>
        <h1 className="ns-login-title-sm">Create Account</h1>
        <p className="ns-login-subtitle-sm">Join NineSistersJewels admin panel</p>
        {error && <div className="ns-alert-error"><i className="bi bi-exclamation-circle"></i> {error}</div>}
        <form onSubmit={onSubmit} className="ns-form-col">
          <div>
            <label className="ns-label">Full Name</label>
            <input className="ns-input" value={name} onChange={e => setName(e.target.value)} placeholder="Your name" required />
          </div>
          <div>
            <label className="ns-label">Email</label>
            <input className="ns-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="email@example.com" required />
          </div>
          <div>
            <label className="ns-label">Password</label>
            <input className="ns-input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Choose a password" required />
          </div>
          <button type="submit" className="btn-theme ns-btn-full-lg" disabled={loading}>
            {loading ? "Creating..." : <><i className="bi bi-person-plus"></i> Create Account</>}
          </button>
        </form>
        <div className="ns-login-back">
          Already have an account? <Link to="/admin/login" className="ns-login-link-primary">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
